// Client-side narration estimate for instant UX (§11). The backend recalculates
// with the same rate and is authoritative (422 DURATION_BUDGET on overflow).
// Rate follows the narrator: Elliott's Inworld voice (Maisie at 1.15x) reads
// lesson text at about 230 words per minute; 200 mirrors the server's
// DEFAULT_SPEECH_RATE and leaves headroom so scripts land under the target.

export const WORDS_PER_MINUTE = 200;
export const EXPLAINER_LOCKED_SECONDS = 5; // 3 s opening + 2 s closing

export function countWords(text: string | null | undefined): number {
  if (!text) return 0;
  return text
    .split(/\s+/)
    .map((w) => w.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, ''))
    .filter((w) => w.length > 0).length;
}

export function estimateSeconds(text: string | null | undefined): number {
  const words = countWords(text);
  if (!words) return 0;
  return Math.round((words / WORDS_PER_MINUTE) * 60 * 10) / 10;
}

export function itemSeconds(narration: string, actualSeconds?: number | null): number {
  return typeof actualSeconds === 'number' && actualSeconds > 0
    ? Math.round(actualSeconds * 10) / 10
    : estimateSeconds(narration);
}

export function budgetFor(mode: 'presenter' | 'explainer', targetDurationSeconds: number): number {
  return mode === 'explainer' ? Math.max(0, targetDurationSeconds - EXPLAINER_LOCKED_SECONDS) : targetDurationSeconds;
}

// Same rule as the server: a change is allowed when the new total fits, OR
// when it does not increase the total (deleting/shortening at the limit).
export function isEditAllowed(previousTotal: number, nextTotal: number, budget: number): boolean {
  if (nextTotal <= budget + 0.05) return true;
  return nextTotal <= previousTotal + 0.05;
}

export function formatClock(seconds: number): string {
  const total = Math.max(0, Math.round(seconds));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function formatApprox(seconds: number): string {
  return `~${formatClock(seconds)}`;
}
